import { useQuery } from "@tanstack/react-query";
import apiClient from "services/ApiClient";
import { API_ROUTES } from "definitions/constants/routeConstants";
import { DashboardHomePayload } from "./types";

export const dashboardHomeKeys = {
  all: ["dashboardHome"] as const,
  detail: () => [...dashboardHomeKeys.all, "detail"] as const,
};

export function useDashboardHomeQuery() {
  return useQuery<DashboardHomePayload>({
    queryKey: dashboardHomeKeys.detail(),
    queryFn: () => apiClient.get<DashboardHomePayload>(API_ROUTES.dashboard.home),
    staleTime: 1000 * 60 * 3,
  });
}
